import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { userSelectors } from 'reducers';
import { subscriptionStatus } from 'utils/constants';
import { useSubscriptionFormSignatureStatus } from 'utils/hooks';
import { texts } from 'utils/languages/fr';

import { SubscriptionInfo } from 'containers/investor-pages';
import PortfolioTable from './ProtfolioTable';
import { Box, Typography } from '@mui/material';

const Portfolio = () => {
    const { subscriptions } = useSelector(userSelectors.getInternalUser);
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const finishedSubscriptions = useMemo(
        () =>
            subscriptions.filter(
                s =>
                    s.subscriptionStatus === subscriptionStatus.FINISHED && s.investmentFund.visible
            ),
        [subscriptions]
    );

    const hasSignedBS = useSubscriptionFormSignatureStatus(tunnelSubscription);

    return (
        <Box
            sx={theme => ({
                minHeight: `calc(100% - ${theme.constants.footerHeight}px)`,
                paddingTop: '60px',
                backgroundColor: theme.palette.common.white,
            })}
        >
            <Typography
                sx={theme => ({
                    mb: '60px',
                    [theme.breakpoints.down('md')]: {
                        fontSize: 30,
                    },
                })}
                variant="h2"
                align="center"
            >
                {texts.MY_PORTFOLIO} {texts.AS_OF} {moment().format('D MMMM YYYY')}
            </Typography>
            <PortfolioTable finishedSubscriptions={finishedSubscriptions} />
            {/* this is only for the ongoing subscription (status = in_progress) */}
            {hasSignedBS && (
                <Box
                    textAlign="center"
                    display="flex"
                    alignItems="center"
                    paddingY={8}
                    flexDirection="column"
                >
                    <SubscriptionInfo subscription={tunnelSubscription} />
                </Box>
            )}
        </Box>
    );
};

export default Portfolio;
